module.exports = new __parcel__URL__("gold1.66595575.png").toString();